import axiosInstance from "../lib/axios";

interface GetProjectRequest {
  page?: number;
  limit?: number;
}

export const getProject = async ({
  page = 1,
  limit = 10,
}: GetProjectRequest) => {
  const body = {
    page,
    limit,
  };

  const { data } = await axiosInstance.post("/Project/List", body);

  return data;
};

export const createProject = (formData: FormData) => {
  return axiosInstance.post("/Project/Create", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getProjectById = (id: number) => {
  return axiosInstance.get(`/Project/${id}`);
};

export const editProject = (
  id: number,
  formData: FormData
) => {
  return axiosInstance.put(`/Project/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteProjectById = (id: number) => {
  return axiosInstance.delete(`/Project/${id}`);
};

